import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'lib-flexible/flexible'
import './utils/axios'
import shareInfo from './api/weixinShare';
import { BrowserRouter, HashRouter } from 'react-router-dom'
let year = new Date().getFullYear()
let mon = new Date().getMonth()  + 1
let day  = new Date().getDate()
shareInfo.init({
  img: 'http://static.nbd.com.cn/images/app/nbd_icon_300_normal.png',
  title: year + '年' + mon + '月' + day + '日' + ' 每经日历',
  desc: '收藏！一览2023年财经大事件，抢先了解全球重磅资讯',
  shareURL: 'https://www.nbd.com.cn/corp/NBDCalendar/build/index.html'
})
const root = ReactDOM.createRoot(document.getElementById('root'));







root.render(
  // <React.StrictMode>
  <HashRouter>
    <App />
  </HashRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
